import {memo} from 'react';

import type {SVGProps} from 'react';

export const SollapayLogomarkIllustration = memo(function SollapayLogomarkIllustration(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="15.62 32.88 38.49 40.33"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M47.67,48.9c-2.03-1.12-4.14-1.52-6.12-1.79l-15.77-2.16c-.78-.11-1.48-.68-1.73-1.44-.26-.79-.11-1.69.41-2.41.49-.68,1.23-1.07,2.02-1.07l26.26-.02v-7.12s-25.79-.01-25.79-.01h0c-3.28,0-6.22,1.42-8.09,3.89-2.06,2.73-2.59,6.2-1.41,9.28,1.19,3.11,3.95,5.41,7.05,5.84l16.42,2.3c3.29.46,5.26,1.74,5.85,3.8.89,3.07-.59,6.22-3.52,7.47-1.74.74-3.64.86-5.35.32-3.15-.99-6.55-4.56-8.52-7.66-1.86-2.92-4.98-4.25-8.16-3.48-3.22.79-5.56,3.68-5.57,6.88l-.03,11.4,7.08.02v-11.19c.02-.06.11-.19.18-.23.1,0,.26.06.34.18,2.92,4.35,7.65,9.82,13.57,11.14,1.1.24,2.21.37,3.32.37,1.62,0,3.24-.26,4.8-.78,6.59-2.19,10.4-8.92,8.86-15.66-.76-3.33-2.92-6.12-6.09-7.86"
      />
    </svg>
  );
});
